function countdownVeil(){
    const content = `
    <style>
    .countdown {
    display: inline-flex;
    gap: 1rem;
    font: 600 2rem/1.2 system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji";
    }

    .segment {
    text-align: center;
    min-width: 6ch;
    }

    .value {
    display: block;
    font-size: 2.25rem;
    }

    .label {
    display: block;
    font-size: 0.85rem;
    opacity: 0.75;
    letter-spacing: .04em;
    text-transform: uppercase;
    }

    #form_container {
    text-align: center;
    // background-color: darkgreen;
    border-radius: 10px;
    color: white;
    padding: 20px;
    max-width: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    }

    .headerText {
        color: white;
    }

    .banner_image {
        display: block;
        margin: auto;
        width: 20%;
    }

    #outer_container {
        display: flex;
        position: fixed;
        width: 100%;
        height: 100%;
        z-index: 11;
        top: 0;
        left: 0;
    }

    #veil {
        width: 100%;
        height: 100%;
        background-color: black;
        opacity: 0.3;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10;
    }
    </style>

    <div id="veil">test</div>
    <div id="outer_container">
        <div id="form_container">
            <img src="https://cdn.shopify.com/s/files/1/0643/5212/5174/files/pickle_mailer.png?v=1760545909" class="banner_image" />
            <h1 class="headerText">OUR ONLINE STORE REOPENS IN</h1>
            <div class="countdown" aria-live="polite" aria-label="Countdown to November 14 at 7 PM">
                <div class="segment" aria-label="Days">
                    <span id="cd-days" class="value">0</span>
                    <span class="label">Days</span>
                </div>
                <div class="segment" aria-label="Hours">
                    <span id="cd-hours" class="value">0</span>
                    <span class="label">Hours</span>
                </div>
                <div class="segment" aria-label="Minutes">
                    <span id="cd-mins" class="value">0</span>
                    <span class="label">Minutes</span>
                </div>
                <div class="segment" aria-label="Seconds">
                    <span id="cd-secs" class="value">00</span>
                    <span class="label">Seconds</span>
                </div>
            </div>
            <div>
                <br/>
                <button id="ok_button">Got it!</button>
            </div>
        </div>
    </div>
    `

    const elem = document.createElement('div')
    elem.id = 'countdown_content';
    elem.innerHTML = content;
    document.body.appendChild(elem)
}

function setCountdown(targetTime) {
    const target = new Date(targetTime);
    const elDays = document.getElementById("cd-days");
    const elHours = document.getElementById("cd-hours");
    const elMins = document.getElementById("cd-mins");
    const elSecs = document.getElementById("cd-secs");

    function pad2(n) { return n.toString().padStart(2, "0"); }

    function tick() {
        const now = new Date();
        let ms = target - now;

        if (ms <= 0) {
            elDays.textContent = "0";
            elHours.textContent = "0";
            elMins.textContent = "0";
            elSecs.textContent = "00";
            clearInterval(timer);
            return;
        }

        const MS_DAY = 24 * 60 * 60 * 1000;
        const MS_HOUR = 60 * 60 * 1000;
        const MS_MIN = 60 * 1000;

        const days = Math.floor(ms / MS_DAY);
        ms %= MS_DAY;

        const hours = Math.floor(ms / MS_HOUR);
        ms %= MS_HOUR;

        const minutes = Math.floor(ms / MS_MIN);
        ms %= MS_MIN;

        const seconds = Math.floor(ms / 1000);

        elDays.textContent = days;
        elHours.textContent = hours;
        elMins.textContent = minutes;
        elSecs.textContent = pad2(seconds);
    }

    tick();
    const timer = setInterval(tick, 250);
}

const countdownTime = "2025-11-14T12:00:00";

// window.addEventListener('DOMContentLoaded', () => {
//     const now = new Date();
//     if (new Date().getTime() > new Date(countdownTime).getTime()) {
//         console.log('Got here')
//         return
//     }
//     countdownVeil();
//     setCountdown(countdownTime);
//     const okButton = document.getElementById('ok_button');
//     okButton.addEventListener('click', () => {
//         window.location.href = "/";
//     })
// })
